import qs from 'qs';
import request from '../utils/request';
// 获取派件列表
export const packagesList = (param) => request(`/admin/package?${qs.stringify(param)}`);
// 派件历史
export const historyPackageList = (param) => request(`/admin/package/package-history?${qs.stringify(param)}`);
// 获取寄件列表
export const deliveryList = (param) => request(`/admin/delivery?${qs.stringify(param)}`);
// 修改派件数据
export const modifyPackage = (id, data) => request({
  url: `/admin/package/${id}`,
  data,
  method: 'put',
});
// 出站
export const outbound = (id) => request({
  url: `/admin/package/outbound/${id}`,
  method: 'put',
});
// 派件数据详情
export const getPackageDetail = (id) => request(`/admin/package/${id}`);
// 重新入站
export const inboundAgain = (id) => request({
  url: `/admin/package/inbound-again/${id}/1`,
  method: 'put',
});
// 开箱
export const packageOpenBox = (id) => request({
  url: `/admin/package/open-box/${id}`,
  method: 'put',
});
// 重发短信
export const resendSms = (id) => request(`/admin/package/sms-resend/${id}`);
// 设置面单
export const setFreeOfCharge = (id) => request({
  url: `/admin/package/set-freeOf-charge/${id}`,
  method: 'put',
});

// updateCcrResult
export const updateOcrResult = (id, data) => request({
  url: `/admin/packages/update-ocr-result/${id}`,
  method: 'put',
  data,
});
